export default class CaptchaError extends Error {
  captchaError = true

  constructor(message: string = 'Captcha Error') {
    super(message)
  }
}
